var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deductions.length
    ? _c(
        "vs-table",
        { attrs: { headings: _vm.deductionHeadings } },
        _vm._l(_vm.deductions, function(deduction, index) {
          return _c("div", { key: index, staticClass: "vs-table__row" }, [
            _c(
              "div",
              {
                staticClass: "vs-table__cell details__half-cell",
                attrs: { "data-heading": _vm.deductionHeadings[0] }
              },
              [_c("h6", [_vm._v(_vm._s(deduction.memo))])]
            ),
            _c(
              "div",
              {
                staticClass: "vs-table__cell details__half-cell",
                attrs: { "data-heading": _vm.deductionHeadings[1] }
              },
              [_c("h6", [_vm._v("-" + _vm._s(_vm.currency(deduction.amount)))])]
            )
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }